export const iconSizes = {
	iconMobile: 22,
	iconTablet: 22,
	iconLaptop: 22,
	iconDesktop: 38,
	iconDesktopLarge: 38,
};

export const closeIconSizes = {
	iconMobile: 30,
	iconTablet: 30,
	iconLaptop: 30,
	iconDesktop: 55,
	iconDesktopLarge: 55,
};
